import React, { useEffect, useRef, useState } from "react";
import {
  Form, 
  Spin, 
  Modal, 
  Input,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";   
import { save } from "../../../../features/save/saveSlice";
 
const WtrAbstractionAdd = ({ isModalOpen, handleCancel, handleFetch, prodd }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const { saving } = useSelector((state) => state.save); 
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onFinish = async (data) => {
    data.waId = prodd?.waId ? prodd?.waId : null;
    const res = await dispatch(
      save({
        ...data,
        url: "water_abstraction_mode/save_waterabstractionmode",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await handleFetch();
      await form.resetFields();
      await handleCancel();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  useEffect(() => {
    if (prodd) {
      form.setFieldsValue({
        ...prodd, 
      });
    } else {
      form.resetFields();
    }
  }, [prodd, form]);

  return (
    <Modal
      title={`${prodd?.waId ? "Update Water Abstraction" : "Add Water Abstraction"}`}
      open={isModalOpen}
      onOk={onFinish}
      onCancel={handleCancel}
      className="!w-[49.5rem]"
      maskClosable={false}
    >
      <Form
        layout="vertical"
        ref={formRef}
        name="control-ref"
        onFinish={onFinish}
        className=""
        style={{
          maxWidth: "100%",
        }}
        form={form}
      > 
          <Form.Item
            name="waType"
            label={"Name"}
            rules={[
              {
                required: true,
                message: "Please add name",
              },
            ]}
          >
            <Input
              className="input"
            />
          </Form.Item> 
        <div className="flex justify-between mt-[48px] ">
          <div className="justify-start"></div>
          <div className="justify-end flex items-center mb-[58px] gap-x-5">
            <div className="w-[150px]">
              <button
                type="button"
                key="back"
                onClick={handleCancel}
                className="cstm-btn"
              >
                Cancel
              </button>
            </div>

            <div className="w-[150px]">
              <button
                disabled={saving}
                key="submit"
                type="submit"
                className="cstm-btn-2"
              >
                {saving ? (
                  <Spin />
                ) : prodd?.waId ? (
                  "Update"
                ) : (
                  "Save"
                )}
              </button>
            </div>
          </div>
        </div>
      </Form>
    </Modal>
  );
};
export default WtrAbstractionAdd;
